import { BonusStat } from '@/api/type-response'

// bonusStat is only returned by newer backend versions; treat partial data as absent
export const getBonusStat = (account: { bonusStat?: BonusStat }): BonusStat | null => {
  const stat = account.bonusStat
  if (!stat) {
    return null
  }
  if (!stat.rechargeBonus || !stat.transferBonus || !stat.otherBonus || !stat.giftBonus) {
    return null
  }
  return stat
}
